import appSettings from '../appSettings';

export const getBaseURL = (): string => {
  let uri = `${globalThis.location.protocol}//${globalThis.location.hostname}`;
  if (uri.includes('localhost')) {
    uri = `${uri}:${globalThis.location.port}`;
  }

  return uri;
};

export const onSignIn = () => {
  const currentUrl = globalThis.location.href;
  const baseUrl = currentUrl.split('/Callback')[0];
  globalThis.history.replaceState({}, document.title, baseUrl);
};
export const onSignOut = (): void => {
  globalThis.location.replace(appSettings.OIDC_END_SESSION_ENDPOINT);
};
